(() => {

    // Third-party scripts start on the first user interaction, or after this delay
    // (counted from window "load") so visitors who never interact are still tracked.
    const FALLBACK_DELAY_MS = 8000;
    const ACTIVITIES = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress', 'touchmove'];

    let active = false;

    const dispatchActivity = () => {
        if (active) {
            return;
        }
        active = true;
        ACTIVITIES.forEach((activity) => window.removeEventListener(activity, dispatchActivity));
        document.dispatchEvent(new CustomEvent('UserInteracted'));
    };

    ACTIVITIES.forEach((activity) => {
        window.addEventListener(activity, dispatchActivity, { passive: true });
    });

    const scheduleFallback = () => setTimeout(dispatchActivity, FALLBACK_DELAY_MS);

    if (document.readyState === 'complete') {
        scheduleFallback();
    } else {
        window.addEventListener('load', scheduleFallback, { once: true });
    }

})();